<template>
  <div class="agency-info">
    <h2 class="inner-title">Assistenza</h2>
    <p>
      <strong>Telefono</strong>: 02.407.413.58
      <br />
      <strong>E-mail</strong>:
      <a href="mailto:assistenza@wichee.com" target="_blank"
        >assistenza@wichee.com</a
      >
    </p>
    <p class="copy mt-4 text-center">
      <small>Copyright &copy; {{ currentYear }} | All rights reserved.</small>
    </p>
  </div>
</template>
<script>
import moment from "moment";
moment.locale("it");
export default {
  computed: {
    currentYear() {
      return moment().year();
    },
  },
};
</script>
<style lang="scss" scoped>
.agency-info {
  margin-top: 3rem;
}
.agency-info .inner-title,
.agency-info strong {
  font-weight: 500;
}
.agency-info .inner-title {
  font-size: var(--font-size-md);
  margin-bottom: 0.2rem;
}
.agency-info a {
  color: inherit;
  text-decoration: underline;
}
.agency-info p {
  margin-bottom: 0;
}
.copy {
  small {
    color: var(--color-text-muted);
  }
}
@media (hover: hover) and (pointer: fine) {
  .agency-info a:hover {
    text-decoration: none;
  }
}
</style>
